import styles from './Excel.module.css';
import image from '../../../../assets/img/excel.svg';
import {createWorkbook} from '../../../../utilities/excelUtilities';

function Excel({rows, columns, title}) {
    let columnWidths = [];
    const exportToExcel = () => {
        columns.forEach(column => columnWidths.push(column.length + 2));
        const name = title || 'Book1';
        createWorkbook(columns, rows, name, columnWidths);
    };

    return (
        <img src={image} alt="Excel" onClick={exportToExcel} className={styles.image}/>
    )
}

export default Excel;